import {SearchSuggestionModel} from '../models/SearchSuggestionModel';
import {Collection} from './Collection';

export class SearchSuggestionCollection extends Collection {
  get model() {
    return SearchSuggestionModel;
  }
}
